// Import React and React Router
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';

// Import pages from pages folder
import Home from './pages/Home';
import About from './pages/About';
import Members from './pages/Members';
import Message from './pages/Message';
import Project from './pages/Project';
import Survey from './pages/Survey';
import Error from './pages/Error';
import Task from './pages/Task';
import Zahid from './pages/Zahid';
import Week from './pages/Week';
import Project_overview from './pages/Project_overview';
import System_Architecture from './pages/System_Architecture';
import Block_Diagram from './pages/Block_Diagram';
import Gantt_Chart from './pages/Gantt_Chart';
import Equipments from './pages/Equipments';
import LitaratureReview from './pages/LitaratureReview';
import PaperWorks from './pages/PaperWorks';
import Sketch from './pages/Sketch';
import Resources from './pages/Resources';
import Software from './pages/Software';
import Hardware from './pages/Hardware';
import SystemDesign from './pages/SystemDesign';
import WorkingMethod from './pages/WorkingMethod';
import CircuitDesign from './pages/CircuitDesign';
import Excel from './pages/Excel';
import Contribution from './pages/Contribution';






// Import Navbar from components folder
import Navbar from './components/Navbar';

// Import css file from css folder
import './App.css';



function App() {
  
  return (
    <BrowserRouter>
    <Navbar/>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/members" element={<Members />} />
      <Route path="/message" element={<Message />} />
      <Route path="/project" element={<Project />} />
      <Route path="/survey" element={<Survey />} />
      <Route path="*" element={<Error />} />
      <Route path="/task" element={<Task />} />
      <Route path="/week" element={<Week />} />
      <Route path="/project_overview" element={<Project_overview />} />
      <Route path="/block_diagram" element={<Block_Diagram />} />
      <Route path="/gantt_chart" element={<Gantt_Chart/>} />
      <Route path="/system_architecture" element={<System_Architecture />} />
      <Route path="/zahid" element={<Zahid />} />
      <Route path="/equipments" element={<Equipments />} />
      <Route path="/litarature_review" element={<LitaratureReview />} />
      <Route path="/paper_works" element={<PaperWorks />} />
      <Route path="/sketch" element={<Sketch />} />
      <Route path="/resources" element={<Resources />} />
      <Route path="/software" element={<Software />} />
      <Route path="/hardware" element={<Hardware />} />
      <Route path="/working_method" element={<WorkingMethod />} />
      <Route path="/system_design" element={<SystemDesign />} />
      <Route path="/Circuit_design" element={<CircuitDesign />} />
      <Route path="/excel" element={<Excel />} />
      <Route path="/contribution" element={<Contribution />} />
  


    </Routes>
    </BrowserRouter>
  );
}

export default App;
